import { createContext } from 'react';

/**
 * @typedef {import('react').Context} Context
 */

/**
 * Creates a Context instance with a displayName
 * 
 * @param {string} name The name to give the Context
 * @param {*} value The default value for the context
 * @returns {Context}
 */
export const createNamedContext = (name, value = null) => {
    const ctx = createContext(value);
    ctx.displayName = name;
    return ctx;
};